export const DEFAULT_ROOT_URL_PART = '';
